var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01611 12.8227C1.01611 10.9684 1.67028 9.22605 2.89267 7.24369C4.03281 5.3947 5.63936 3.37925 7.61733 0.897841C7.64264 0.866088 7.66801 0.834258 7.69345 0.802352C7.71899 0.834396 7.74447 0.866362 7.76989 0.898251C9.74771 3.37947 11.3542 5.39481 12.4943 7.24369C13.7167 9.22606 14.3709 10.9684 14.3709 12.8227C14.3709 16.5101 11.3812 19.5 7.69345 19.5C4.00557 19.5 1.01611 16.5101 1.01611 12.8227Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3711 7.6936C15.3711 6.63222 15.7442 5.62371 16.4673 4.45119C17.123 3.38783 18.04 2.22962 19.1775 0.802297C20.315 2.22962 21.232 3.38783 21.8878 4.45119C22.6108 5.62372 22.9839 6.63223 22.9839 7.6936C22.9839 9.79562 21.2797 11.5 19.1775 11.5C17.0752 11.5 15.3711 9.79564 15.3711 7.6936Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur);
export default __webpack_public_path__ + "static/media/blur.cec8e37577e0d6c5e328da0996772386.svg";
export { ForwardRef as ReactComponent };